import { Component, OnInit, ViewContainerRef, ViewChildren, Inject, ComponentFactoryResolver, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MfPanelComponent } from '../mf-panel/mf-panel.component';

@Component({
  selector: 'app-mf-popup-panel-v2',
  templateUrl: './mf-popup-panel-v2.component.html',
  styleUrls: ['./mf-popup-panel-v2.component.css']
})
export class MfPopupPanelComponentV2 implements OnInit {
  @ViewChild('formDetails', { read: ViewContainerRef }) public formDetails: ViewContainerRef;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private componentFactoryResolver: ComponentFactoryResolver,
    public dialogRef: MatDialogRef<MfPopupPanelComponentV2>) {
  }
  public componentInstance: any;
  ngOnInit() {
  }

  public ngAfterViewInit() {

    this.buildForm();
  }

  public closeDialog(action) {
    this.dialogRef.close({ action: action, scope: this, selectedItems: this.componentInstance.componentInstance[0].component.lazyTable.selectedItems  });
  }

  private buildForm() {
    let target = this.formDetails;
    var component = this.data.component;
    let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(MfPanelComponent);
    let componentRef: any = target.createComponent(widgetComponent);
    this.componentInstance = (componentRef.instance);
    this.componentInstance.parent = this;
    this.componentInstance.formIndex = component.index;
    this.componentInstance.displayName = component.displayName;
    this.componentInstance.hideClose = component.hideClose;
    this.componentInstance.entityOptions = component.entityOptions;
    this.componentInstance.formOptions = component.formOptions;
    this.componentInstance.gridOptions = component.gridOptions;
    this.componentInstance.formOnly = component.formOnly;
    this.componentInstance.index = 0;
    this.componentInstance.isDialog = true;
    this.componentInstance.dialogRef = this.dialogRef;
    if (this.componentInstance.load) this.componentInstance.load();

  }
}
